module.exports = __webpack_public_path__ + "static/banner-img-117b26ce8413241603b8cff89c958204.png";